import { render, staticRenderFns } from "./EditDriver.vue?vue&type=template&id=0c36bf3e&scoped=true&"
import script from "./EditDriver.vue?vue&type=script&lang=js&"
export * from "./EditDriver.vue?vue&type=script&lang=js&"
import style0 from "./EditDriver.vue?vue&type=style&index=0&media=screen&lang=css&"
import style1 from "./EditDriver.vue?vue&type=style&index=1&id=0c36bf3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36bf3e",
  null
  
)

export default component.exports